import { MultiSelect, MultiSelectProps } from 'primereact/multiselect';
import './MlxMultiSelect.scss';

type MlxMultiSelectProps = MultiSelectProps & {
    dropDownSize?: 'small' | 'large';
};

const MlxMultiSelect = (props: Readonly<MlxMultiSelectProps>) => {
    let { className, dropDownSize, ...rest } = props;

    // Update class name
    if (!className) {
        className = '';
    }
    className = 'mlx-multi-select ' + className;

    if (dropDownSize) {
        className += ` ${dropDownSize}-multiselect`;
    }

    return <MultiSelect className={className} {...rest} />;
};

export default MlxMultiSelect;
